import { companyProfileTitleScrollFill } from "../modules/companyProfileTitleScrollFill";
import { footerImagesReveal } from "../modules/footerImagesReveal";
import { menu } from "../modules/menu";
// AlpineModules
import { homeMv } from "../alpineModules/homeMv";
import { companyLineInview } from "../alpineModules/companyLineInview";

export const initScripts = () => {
  const cleanupFunctions: (() => void)[] = [];

  const companyProfileTitleFillCleanup = companyProfileTitleScrollFill();
  if (companyProfileTitleFillCleanup) {
    cleanupFunctions.push(companyProfileTitleFillCleanup);
  }

  const footerImagesRevealCleanup = footerImagesReveal();
  if (footerImagesRevealCleanup) {
    cleanupFunctions.push(footerImagesRevealCleanup);
  }

  return cleanupFunctions;
}

export const initAlpineScripts = () => {
  document.addEventListener("alpine:init", () => {
    menu();
    homeMv();
    companyLineInview();
  });
};
